import {OrderType} from "../services/Api/types";

export const getParsedSessionOrderType = (orderType: string | undefined) => orderType === OrderType.PICK_UP ? "takeaway" : orderType ?? "";